import {
  CircleCheck,
  Info,
  Loader2,
  OctagonX,
  TriangleAlert,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = (props: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        error: <OctagonX className="size-4" />,
        info: <Info className="size-4" />,
        loading: <Loader2 className="size-4 animate-spin" />,
        success: <CircleCheck className="size-4" />,
        warning: <TriangleAlert className="size-4" />,
      }}
      position="top-center"
      richColors
      toastOptions={{
        classNames: {
          toast: "border border-border rounded-xl shadow-lg",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
